import { render, staticRenderFns } from "./PaginaVigiliDelFuoco.vue?vue&type=template&id=7fd236c0"
import script from "./PaginaVigiliDelFuoco.vue?vue&type=script&lang=js"
export * from "./PaginaVigiliDelFuoco.vue?vue&type=script&lang=js"
import style0 from "./PaginaVigiliDelFuoco.vue?vue&type=style&index=0&id=7fd236c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports